export const Youtube = (props: SocialIconProps) => {
  const { className } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" className={className}>
      <rect
        width={62}
        height={62}
        x={1}
        y={1}
        className="fill-surface-secondary stroke-skin-stroke"
        strokeWidth={2}
        rx={31}
      />
      <g clipPath="url(#bca)">
        <path
          className="fill-skin-primary"
          fillRule="evenodd"
          d="M32 21.333c1.14 0 2.31.03 3.443.078l1.339.064 1.281.076 1.2.081 1.096.085a5.067 5.067 0 0 1 4.659 4.564l.053.567.1 1.213c.093 1.258.163 2.628.163 3.939 0 1.31-.07 2.681-.163 3.939l-.1 1.213-.053.567a5.067 5.067 0 0 1-4.66 4.564l-1.094.084-1.2.082-1.282.076-1.339.064a82.68 82.68 0 0 1-3.443.078 82.679 82.679 0 0 1-3.442-.078l-1.339-.064-1.281-.076-1.2-.082-1.096-.084a5.067 5.067 0 0 1-4.659-4.564l-.053-.567-.1-1.213A54.61 54.61 0 0 1 18.667 32c0-1.31.07-2.681.163-3.939l.1-1.213.053-.567a5.066 5.066 0 0 1 4.657-4.564l1.095-.085 1.2-.081 1.283-.076 1.338-.064A82.574 82.574 0 0 1 32 21.333Zm-2.666 7.434v6.466a.8.8 0 0 0 1.2.694l5.6-3.234a.801.801 0 0 0 0-1.386l-5.6-3.232a.8.8 0 0 0-1.2.693v-.001Z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="bca">
          <path fill="#fff" d="M16 16h32v32H16z" />
        </clipPath>
      </defs>
    </svg>
  );
};
